import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";
import ShareHolderSideBar from "./ShareHolderSideBar";
import Layout from "~/Layout";
import apiService from "~/services/service";
import API_ROUTES from "~/api-routes";

const ShareHolderContext = createContext();

const ShareHolderDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [regData, setRegData] = useState({});
  const [loading, setLoading] = useState(true);
  let initialOfficerData = useRef({});

  useEffect(() => {
    fetchOfficerData();
  }, []);

  const fetchOfficerData = async () => {
    setLoading(true);
    const { data } = await apiService(API_ROUTES.FETCH_SHAREHOLDER, "GET", {
      replace: { id },
    });

    setRegData(data);
    setLoading(false);
    initialOfficerData.current = data;
  };

  const resetRegData = (data = {}) => {
    const mergedData = {
      ...initialOfficerData.current,
      ...data,
    };
    setRegData(mergedData);
  };

  const breadcrumbs = [
    {
      label: <span className="breadcrumb-link">My Entities</span>,
      command: () => navigate("/entities"),
      id: "entities",
    },
    {
      label: (
        <Link
          to={`/entity/${regData.entityData?.id}/dashboard`}
          className="link__style flex"
        >
          {!loading ? (
            regData?.entityData?.name
          ) : (
            <Skeleton width="100px" height="20px" className="mr-1" />
          )}
          {!loading ? (
            " "
          ) : (
            <Skeleton width="10px" height="20px" className="mr-1" />
          )}
          {!loading ? (
            <>
              (
              <ReactCountryFlag
                countryCode={regData?.entityData?.country || ""}
                svg
                className=""
              />{" "}
              {getName(regData.entityData?.country || "")})
            </>
          ) : (
            <Skeleton width="150px" height="20px" className="mr-1" />
          )}
        </Link>
      ),
      id: "entity",
    },
    {
      label: <span className="breadcrumb-link">Directors & Shareholders</span>,
      command: () => navigate(`/entity/${regData.entity}/share-holders`),
      id: "shareholder-data",
    },
    {
      label: (
        <>
          {!loading ? (
            regData?.type === "Individual" ? (
              `${regData?.name} ${regData?.last_name}`
            ) : (
              `${regData?.legal_name}`
            )
          ) : (
            <Skeleton width="100px" height="20px" className="mr-1" />
          )}
        </>
      ),
    },
  ];

  return (
    <ShareHolderContext.Provider
      value={{ regData, setRegData, resetRegData, loading }}
    >
      <Layout crumbs={breadcrumbs}>
        <div className="grid grid-nogutter">
          <div className="col-12 Entities-container">
            <div className="grid">
              <div className="col-3">
                <ShareHolderSideBar />
              </div>
              <div className="col-9">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </ShareHolderContext.Provider>
  );
};

export default ShareHolderDetail;
export const useShareHolderDetails = () => useContext(ShareHolderContext);
